import * as React from 'react';
import { useInterval } from '../../../misc/Hooks/UseInterval';

import { ImportEvent } from '../ImportEventsReducer';

export interface ImportingPageProps {
    startImporting: () => void;
    eventsList: Array<ImportEvent>;
}

export const ImportingPage = (props: ImportingPageProps) => {
    const [debouncedStatusText, setDebouncedStatusText] = React.useState(null);

    useInterval(() => setDebouncedStatusText(props.eventsList.filter(x => x.IsImporting > 1).length), 2000);

    React.useEffect(() => {
        props.startImporting();
    }, []);

    if (props.eventsList.length === 0) {
        return null;
    }

    return (
        <div
            className="text-center">
            <p
                style={{ fontSize: 100 + 'px' }}
                className="text-center text-info">
                <i
                    className="fas fa-spin fa-circle-notch"
                    aria-hidden="true"></i>
            </p>
            <p className="text-center">Importing event {debouncedStatusText} of {props.eventsList.length}</p>
        </div>
    );
}
